import { formatDate } from "helper/dateFormat";

export const capitalizeFirstLetter = (string) => {
  return `${string.slice(0, 1).toUpperCase()}${string.slice(1)}`;
};
/**
 *
 * @param {string} string
 * @returns {string}
 */
export const capitalizeFirstLetterAndSplitByUnderscore = (string) => {
  return `${string.slice(0, 1).toUpperCase()}${string.slice(1)}`
    .split("_")
    .join(" ");
};

export const isObjectEmpty = (obj) => Object.keys(obj).length === 0;

export const getOrganizationInfoFromLocalStorage = () =>
  JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );

export const CheckFloatValue = (n) => {
  if (n === +n && n !== (n | 0)) {
    return n.toFixed(2);
  } else {
    return n;
  }
};

export const hasAccessToModule = (moduleName) => {
  try {
    const modules = JSON.parse(localStorage.getItem("authorizedModules")) || [];
    return modules.some(
      ({ moduleName: name, active }) => name === moduleName && active
    );
  } catch (err) {
    console.error("Access check error:", err);
    return false;
  }
};


export const downloadBlobFile = ({
  data,
  fileNamePrefix,
  extension = "pdf",
}) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;

  const currentDate = formatDate({
    date: new Date(),
    formatType: "defaultWithUTC",
  });

  const fileName = `${fileNamePrefix}_${currentDate}`;
  link.setAttribute("download", `${fileName}.${extension}`);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};
